module.exports = "<div class=\"loading-overlay\" *ngIf=\"isLoading\">\n  <div class=\"spinner\"></div>\n  <p>Cargando...</p>\n</div>\n"